"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformSourceType = void 0;
var PlatformSourceType;
(function (PlatformSourceType) {
    PlatformSourceType["Web"] = "Web";
    PlatformSourceType["Mobile"] = "Mobile";
})(PlatformSourceType = exports.PlatformSourceType || (exports.PlatformSourceType = {}));
